import * as ReactRuntime from 'react/jsx-runtime';
export const Runtime = ReactRuntime;
